import { render, staticRenderFns } from "./ModalFilesService.vue?vue&type=template&id=8c1264a6"
import script from "./ModalFilesService.vue?vue&type=script&lang=js"
export * from "./ModalFilesService.vue?vue&type=script&lang=js"
import style0 from "./ModalFilesService.vue?vue&type=style&index=0&id=8c1264a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports